import FormMediaFile from 'components/common/forms/FormMediaFile';
import FormAutoHeightTextarea from 'components/common/forms/FormAutoHeightTextarea';
import styles from 'styles/pages/chart/IntraOralCameraChart.module.scss';
import { TAttachmentFiles } from 'types/chart/intraOralCameraChart';
import { IntraOralCameraChartFields } from 'constants/chart/intraOralCameraChart';
import { STYLES_VARIABLES } from 'constants/styleVariables';

type TProps = {
  category: string;
  formMediaFileRefs: React.MutableRefObject<
    Array<{ resetFile: () => void } | null>
  >;
  attachmentFiles: TAttachmentFiles;
  deleteFileIdList: number[];
  setDeleteFileIdList: React.Dispatch<React.SetStateAction<number[]>>;
  changeFile: (index: number, file: File[]) => void;
  isRegister: boolean;
  isReadOnly: boolean;
  activeTabIndex: number;
};

const IntraOralCameraChart = ({
  category,
  formMediaFileRefs,
  attachmentFiles,
  deleteFileIdList,
  setDeleteFileIdList,
  changeFile,
  isRegister,
  isReadOnly,
  activeTabIndex,
}: TProps) => {
  return (
    <>
      <div className={styles.title_wrapper}>
        <span className={styles.rectangle}></span>
        <span className={styles.title}>1차</span>
      </div>
      <div className={styles.content_title_wrapper}>
        <FormAutoHeightTextarea
          name={IntraOralCameraChartFields.round1First}
          placeholder="텍스트를 입력해 주세요."
          readOnly={
            !isRegister ||
            isReadOnly ||
            (category !== 'practice' && activeTabIndex === 2)
          }
          textareaStyle={{
            width: '100%',
            backgroundColor: STYLES_VARIABLES.GRAY_01,
            padding: '14px 12px',
            borderBottom: '0',
            borderTopLeftRadius: '8px',
          }}
        />
        <FormAutoHeightTextarea
          name={IntraOralCameraChartFields.round1Second}
          placeholder="텍스트를 입력해 주세요."
          readOnly={
            !isRegister ||
            isReadOnly ||
            (category !== 'practice' && activeTabIndex === 2)
          }
          textareaStyle={{
            width: '100%',
            backgroundColor: STYLES_VARIABLES.GRAY_01,
            padding: '14px 12px',
            borderBottom: '0',
          }}
        />
        <FormAutoHeightTextarea
          name={IntraOralCameraChartFields.round1Third}
          placeholder="텍스트를 입력해 주세요."
          readOnly={
            !isRegister ||
            isReadOnly ||
            (category !== 'practice' && activeTabIndex === 2)
          }
          textareaStyle={{
            width: '100%',
            backgroundColor: STYLES_VARIABLES.GRAY_01,
            padding: '14px 12px',
            borderBottom: '0',
            borderTopLeftRadius: '8px',
          }}
        />
      </div>
      <div className={styles.chart_container}>
        <div className={styles.photo_wrapper}>
          <FormMediaFile
            ref={(el) => {
              formMediaFileRefs.current[0] = el as {
                resetFile: () => void;
              } | null;
            }}
            files={attachmentFiles[0] ? [attachmentFiles[0]] : []}
            inputId="oralImages1-1"
            readOnly={
              !isRegister ||
              isReadOnly ||
              (category !== 'practice' && activeTabIndex === 2)
            }
            onDelete={(index) =>
              setDeleteFileIdList([...deleteFileIdList, index])
            }
            onChange={(files) => changeFile(0, files)}
          />
        </div>
        <div className={styles.photo_wrapper}>
          <FormMediaFile
            ref={(el) => {
              formMediaFileRefs.current[1] = el as {
                resetFile: () => void;
              } | null;
            }}
            files={attachmentFiles[1] ? [attachmentFiles[1]] : []}
            inputId="oralImages1-2"
            readOnly={
              !isRegister ||
              isReadOnly ||
              (category !== 'practice' && activeTabIndex === 2)
            }
            onDelete={(index) =>
              setDeleteFileIdList([...deleteFileIdList, index])
            }
            onChange={(files) => changeFile(1, files)}
          />
        </div>
        <div className={styles.photo_wrapper}>
          <FormMediaFile
            ref={(el) => {
              formMediaFileRefs.current[2] = el as {
                resetFile: () => void;
              } | null;
            }}
            files={attachmentFiles[2] ? [attachmentFiles[2]] : []}
            inputId="oralImages1-3"
            readOnly={
              !isRegister ||
              isReadOnly ||
              (category !== 'practice' && activeTabIndex === 2)
            }
            onDelete={(index) =>
              setDeleteFileIdList([...deleteFileIdList, index])
            }
            onChange={(files) => changeFile(2, files)}
          />
        </div>
      </div>

      <div className={styles.title_wrapper}>
        <span className={styles.rectangle}></span>
        <span className={styles.title}>2차</span>
      </div>
      <div className={styles.content_title_wrapper}>
        <FormAutoHeightTextarea
          name={IntraOralCameraChartFields.round2First}
          placeholder="텍스트를 입력해 주세요."
          readOnly={
            !isRegister ||
            isReadOnly ||
            (category !== 'practice' && activeTabIndex === 0)
          }
          textareaStyle={{
            width: '100%',
            backgroundColor: STYLES_VARIABLES.GRAY_01,
            padding: '14px 12px',
            borderBottom: '0',
            borderTopLeftRadius: '8px',
          }}
        />
        <FormAutoHeightTextarea
          name={IntraOralCameraChartFields.round2Second}
          placeholder="텍스트를 입력해 주세요."
          readOnly={
            !isRegister ||
            isReadOnly ||
            (category !== 'practice' && activeTabIndex === 0)
          }
          textareaStyle={{
            width: '100%',
            backgroundColor: STYLES_VARIABLES.GRAY_01,
            padding: '14px 12px',
            borderBottom: '0',
            borderTopLeftRadius: '8px',
          }}
        />
        <FormAutoHeightTextarea
          name={IntraOralCameraChartFields.round2Third}
          placeholder="텍스트를 입력해 주세요."
          readOnly={
            !isRegister ||
            isReadOnly ||
            (category !== 'practice' && activeTabIndex === 0)
          }
          textareaStyle={{
            width: '100%',
            backgroundColor: STYLES_VARIABLES.GRAY_01,
            padding: '14px 12px',
            borderBottom: '0',
            borderTopLeftRadius: '8px',
          }}
        />
      </div>
      <div className={styles.chart_container}>
        <div className={styles.photo_wrapper}>
          <FormMediaFile
            ref={(el) => {
              formMediaFileRefs.current[3] = el as {
                resetFile: () => void;
              } | null;
            }}
            files={attachmentFiles[3] ? [attachmentFiles[3]] : []}
            inputId="oralImages2-1"
            readOnly={
              !isRegister ||
              isReadOnly ||
              (category !== 'practice' && activeTabIndex === 0)
            }
            onDelete={(index) =>
              setDeleteFileIdList([...deleteFileIdList, index])
            }
            onChange={(files) => changeFile(3, files)}
          />
        </div>
        <div className={styles.photo_wrapper}>
          <FormMediaFile
            ref={(el) => {
              formMediaFileRefs.current[4] = el as {
                resetFile: () => void;
              } | null;
            }}
            files={attachmentFiles[4] ? [attachmentFiles[4]] : []}
            inputId="oralImages2-2"
            readOnly={
              !isRegister ||
              isReadOnly ||
              (category !== 'practice' && activeTabIndex === 0)
            }
            onDelete={(index) =>
              setDeleteFileIdList([...deleteFileIdList, index])
            }
            onChange={(files) => changeFile(4, files)}
          />
        </div>
        <div className={styles.photo_wrapper}>
          <FormMediaFile
            ref={(el) => {
              formMediaFileRefs.current[5] = el as {
                resetFile: () => void;
              } | null;
            }}
            files={attachmentFiles[5] ? [attachmentFiles[5]] : []}
            inputId="oralImages2-3"
            readOnly={
              !isRegister ||
              isReadOnly ||
              (category !== 'practice' && activeTabIndex === 0)
            }
            onDelete={(index) =>
              setDeleteFileIdList([...deleteFileIdList, index])
            }
            onChange={(files) => changeFile(5, files)}
          />
        </div>
      </div>
    </>
  );
};

export default IntraOralCameraChart;
